import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_simonara-careers/artifacts/myufl7i3_AI-powered%20recruiting%20%26%20HR%20consulting_20260711_112026_0000%20%281%29.png";

/**
 * Simonara Talent Solutions logo — image only, no wordmark text.
 * The supplied artwork already includes the "SIMONARA / TALENT SOLUTIONS" wordmark
 * on a white background, so it renders directly.
 * On dark surfaces (footer) we wrap it in a subtle white tile so the whitespace
 * around the mark reads as intentional.
 */
export const Logo = ({ className = "", size = "md", variant = "default" }) => {
    const sizeClass = {
        sm: "h-10",
        md: "h-12",
        lg: "h-16",
        xl: "h-20 lg:h-24",
        "2xl": "h-24 lg:h-28",
    }[size] || "h-12";

    const isLight = variant === "light";

    if (isLight) {
        // Dark background: wrap in white tile so image bg blends
        return (
            <div className={`inline-flex items-center rounded-xl bg-white shadow-sm ${sizeClass} px-2.5 py-1 ${className}`} aria-label="Simonara Talent Solutions">
                <img
                    src={LOGO_URL}
                    alt="Simonara Talent Solutions"
                    className="h-full w-auto object-contain"
                    loading="eager"
                />
            </div>
        );
    }

    return (
        <img
            src={LOGO_URL}
            alt="Simonara Talent Solutions"
            className={`${sizeClass} w-auto object-contain ${className}`}
            loading="eager"
        />
    );
};

export default Logo;
